import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/wedding';

class WeddingService {
  postClientContract = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/document`, body);
      if (response.status !== 201) {
        throw new Error();
      }

      const { data } = response.data;

      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating to do for client.');
    }
  };

  getClientContracts = async ({ id, page }) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/client/${id}/contracts?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message, maxReached } = response.data;
      const p = response.data.page;

      return { data, message, maxReached, page: p };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching client contracts by id.');
    }
  };

  getDocumentById = async id => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/document/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching document by id.');
    }
  };

  createClientByVendor = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/client`, body);
      if (response.status !== 201) {
        throw new Error();
      }
      const { data, message } = response.data;

      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating client.');
    }
  };

  createHashtagsForClient = async (id, newHashtags, hashtags) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/${id}/client/hashtags`, { hashtags, newHashtags });
      if (response.status !== 201) {
        throw new Error();
      }
      const { data } = response.data;

      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating hashtags for client.');
    }
  };

  deleteDocument = async id => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/vendor/document/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data } = response.data;

      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting client contract.');
    }
  };

  editDocument = async ({ id, name }) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/vendor/document/${id}`, { name });
      if (response.status !== 200) {
        throw new Error();
      }

      const { data } = response.data;

      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while editing client contract.');
    }
  };

  setClientWeddingDate = async (id, body) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/client/${id}/wedding`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;

      return { data, dateOfWedding: body.dateOfWedding, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while setting client wedding date.');
    }
  };

  deleteLeadClient = async id => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/client/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;

      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting client.');
    }
  };

  acceptClientDeleteRequest = async (id, body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/delete-request/accept/${id}`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;

      return { data, id, notificationId: body.notificationId };
    } catch (err) {
      throw handleError(err, 'Error occurred while accepting delete client.');
    }
  };

  sendDeleteRequestToClient = async id => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/delete-request/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;

      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while sending delete request to client.');
    }
  };

  rejectContractDeleteRequest = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/delete-request/reject/`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      response.data.notificationId = body.notificationId;
      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while rejecting delete request.');
    }
  };
}
const weddingService = new WeddingService();

export default weddingService;
